import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { FinalStepsQuestionnaireItem } from './questionnaire'

// Final steps section questionnaire answer type mapping
export const FINAL_STEPS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [FinalStepsQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES]: QuestionnaireAnswerType.STRING,
  [FinalStepsQuestionnaireItem.FINAL_STEPS_CLIENT_REPRESENTATIVE_SIGNATURE]:
    QuestionnaireAnswerType.STRING
}
